/**
 * `#security` — bản tiếng Anh, lấy từ thuộc tính `data-en` của chính các phần tử đó trong
 * `template.html` (994–1010). Hình dạng phải khớp `vi/security.ts`; lệch một khoá là lỗi biên dịch.
 */
interface SecurityCardCopy {
  readonly icon: 'server' | 'key-round' | 'scroll-text' | 'shield-check';
  readonly title: string;
  readonly body: string;
}

export const security = {
  eyebrow: 'Enterprise & deployment',
  heading: 'Runs inside your perimeter when that is the requirement.',
  lead: 'Nexa deploys as managed cloud, private cloud, or fully on-premise — with the same feature set. NewEra Inc. handles migration, integration and operator training.',
  cards: [
    {
      icon: 'server',
      title: 'On-premise',
      body: 'Deploy in your own data centre; data never leaves your network.',
    },
    {
      icon: 'key-round',
      title: 'SSO & roles',
      body: 'Single sign-on with role-based access down to channel and project level.',
    },
    {
      icon: 'scroll-text',
      title: 'Audit & approvals',
      body: 'Every approval and status change is traceable to a person and a time.',
    },
    {
      icon: 'shield-check',
      title: 'Scoped AI',
      body: 'Agents read only the sources their project explicitly links.',
    },
  ] as readonly SecurityCardCopy[],
};
